// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js","771":"component---src-pages-page-2-js","869":"styles"}[chunkId] + "-" + {"125":"d6966d5518f4d902ba4a","293":"f32a558908e41becc6f3","771":"7781332cb12b2af73624","869":"a16d84d7979f2230dda7"}[chunkId] + ".js";
};